// src/components/common/PasswordRequirements.tsx
// Checklist "espelho" dos requisitos de senha (issue #27, item 3). O texto
// AUTORITATIVO é `padraoExigido` (vindo do backend: `padrao_exigido` no 403 ou a
// `mensagem` de erro da troca) — exibido verbatim. O checklist abaixo é só UX:
// antecipa, enquanto o usuário digita, o que já foi atendido. A validação real é
// sempre do backend #58 (ADR-040).
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@/icons';
import { evaluatePassword } from '@/utils/passwordRules';
import './PasswordRequirements.css';

interface PasswordRequirementsProps {
  senha: string;
  // Texto oficial do backend (fonte da verdade). Opcional: o form voluntário
  // (perfil) não recebe um 403, então exibe só o checklist.
  padraoExigido?: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ senha, padraoExigido }) => {
  const { rules } = evaluatePassword(senha);

  return (
    <div className="password-requirements">
      {padraoExigido && <p className="password-requirements-official">{padraoExigido}</p>}
      <ul className="password-requirements-list">
        {rules.map((rule) => (
          <li
            key={rule.id}
            className={rule.met ? 'password-requirement met' : 'password-requirement unmet'}
            data-met={rule.met}
          >
            <FontAwesomeIcon icon={rule.met ? faCheck : faXmark} aria-hidden="true" />
            <span>{rule.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
